import { combineReducers } from 'redux'
import { createReducer } from 'redux-create-reducer'

import searchboxReducer from 'js/scenes/MainSearchBox/redux/reducer';
import secondStep from 'js/components/secondStep/reducers/secondStep'
import globalLoader from 'js/components/Loader/reducers/loaderReducer'
import conditionsReducer from 'js/components/firstStep/reducers/conditionsReducer'
import imagesReducer from "js/scenes/GalleryPopup/reducers/imagesReducer";
import familyFriendlyReducer from "js/components/PopupConstructor/popups/FamilyFriendlyPopup/reducers/familyFriendlyReducer";
import popup from 'js/components/PopupConstructor/reducers/popupReducer'
import extendedReviews from './reviews'
import { urlReducer } from 'js/url/redux/reducer';

export const UPDATE_STORE_VALUE = 'Adagio.UPDATE_STORE_VALUE'

const initialState = {
  pageIndex: null,
  setting: window.drupalSettings,
  results: [],
  activeFilter: '',
  searchUrlHolder: '',
  searchUrlFiltersHolder: '',
  holdKeyword: '',
  basketHashUpdated: null,
  bookingUrl: '',
  homePageVideoBanner: true,
  homePageABtestySearch: true,
  hotelAccordion: {},
  checkoutState: {
    optionsValues: null,
  },
}

const main = createReducer(initialState, {
  [UPDATE_STORE_VALUE](state, { key, value }) {
    if (!key) {
      return { ...state, ...value }
    }

    const keyWay = key.split('.')

    // Handle nested keys
    const updateNestedState = (obj, keys, val) => {
      if (keys.length === 1) {
        return {
          ...obj,
          [keys[0]]: typeof val === 'function' ? val(obj[keys[0]]) : val
        }
      }

      const [firstKey, ...restKeys] = keys
      return {
        ...obj,
        [firstKey]: updateNestedState(obj[firstKey] || {}, restKeys, val)
      }
    }

    return updateNestedState(state, keyWay, value)
  },
})

export default combineReducers({
  main,
  globalLoader,
  extendedReviews,
  conditions: conditionsReducer,
  galleryPopup: imagesReducer,
  familyFriendlyPopup: familyFriendlyReducer,
  popup,
  url: urlReducer,
  // form: form.plugin({
  //   secondStep,
  // }),
  searchBox: searchboxReducer,
  secondStep,
})
